import styled from 'styled-components'

import IconButton from '../Button/IconButton'

const ApartmentButton = styled(IconButton)`
  padding: 0;
  color: ${props => props.theme.colors[props.highlight ? 'primary' : 'secondary']};
  background-color: transparent;
  border: 0;

  path {
    stroke ${props =>
      props.theme.fontColorWithBackground[props.highlight ? 'primary' : 'secondary']};
    stroke-width: 25px;
  }
`

export default ApartmentButton
